import { render } from "./LegalDocumentReader.vue?vue&type=template&id=a883ba08&scoped=true"
import script from "./LegalDocumentReader.vue?vue&type=script&lang=js"
export * from "./LegalDocumentReader.vue?vue&type=script&lang=js"

import "./LegalDocumentReader.vue?vue&type=style&index=0&id=a883ba08&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a883ba08"]])

export default __exports__